import {IExtensionPoints, IPlugin, IServiceConfig} from "@athena-portal/core";
import {
    BaseRequestServiceImpl,
    IBaseRequestService,
    Types
} from "@ferry/journey-services";
import {AnnualMotorDashboardPage} from "../pages/dashboard/annual/motor/dashboardPage/AnnualMotorDashboardPage";
import {DriveAwayDashboardPage} from "../pages/dashboard/driveaway/dashboardPage/DriveAwayDashboardPage";
import {IDashboardPluginConfig} from "./IDashboardPluginConfig";
import {AnnualAccountDetailsPage} from "../pages/dashboard/annual/motor/AnnualAccountDetailsPage";
import {ChangeCardPage} from "../pages/dashboard/common/payments/changeCard/ChangeCardPage"
import {QuotesPage} from "../pages/dashboard/common/quotesPage/QuotesPage"
import {AnnualQuotesPage} from "../pages/dashboard/common/quotesPage/AnnualQuotesPage"
import {PickClaimKindPage} from "../pages/dashboard/common/PickClaimKindPage";
import {MissedPaymentPage} from "../pages/dashboard/common/payments/missedPayment/MissedPaymentPage";
import {PaymentProcessingPage} from "../pages/dashboard/common/payments/PaymentProcessingPage";
import {PickMotorClaimKindPage} from "../pages/dashboard/annual/motor/claims/PickMotorClaimKindPage";
import {WindscreenOrOtherClaimPage} from "../pages/dashboard/annual/motor/claims/WindscreenOrOtherClaimPage";
import {ViewOrGetQuotesPage} from "../pages/dashboard/common/quotesPage/ViewOrGetQuotesPage";
import {
    MonthlyPaymentsDetailsPage
} from "../pages/dashboard/common/payments/paymentDetails/annual/MonthlyPaymentsDetailsPage";
import {YourCarCoverPage} from "../pages/dashboard/annual/motor/yourCarCover/YourCarCoverPage";
import {YourDriveAwayCarCoverPage} from "../pages/dashboard/driveaway/yourCarCover/YourDriveAwayCarCoverPage";
import {AnnualYourCarsPage} from "../pages/dashboard/annual/motor/yourCarsPage/AnnualYourCarsPage";
import {DocumentsPage} from "../pages/dashboard/common/documents/DocumentsPage";
import {
    AnnualPaymentDetailsPage
} from "../pages/dashboard/common/payments/paymentDetails/annual/AnnualPaymentDetailsPage";
import {NewCardPaymentPage} from "../pages/dashboard/common/payments/NewCardPaymentPage";
import {OldPoliciesPage} from "../pages/dashboard/common/OldPoliciesPage";
import {OldMotorPolicySummaryPage} from "../pages/dashboard/annual/motor/oldPolicies/OldMotorPolicySummaryPage";
import {MultiPoliciesDashboardPage} from "../pages/dashboard/common/MultiPoliciesDashboardPage";
import {MultiPolicyAccountDetailsPage} from "../pages/dashboard/common/MultiPolicyAccountDetailsPage";
import {GetNewQuotePage} from "../pages/dashboard/common/quotesPage/GetNewQuotePage";
import {DirectDebitChangePaymentDayPage} from "../pages/dashboard/common/payments/DirectDebitChangePaymentDayPage";
import {PayOffBalancePage} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalancePage";
import {PayOffBalanceNewCardPage} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalanceNewCardPage";
import {CardPaymentProcessingPage} from "../pages/dashboard/common/payments/CardPaymentProcessingPage";
import {
    PayOffBalanceProcessingPage
} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalanceProcessingPage";
import {MarketingPreferencesPage} from "../pages/dashboard/common/MarketingPreferencesPage";
import {DirectDebitChangePage} from "../pages/dashboard/common/payments/changeDirectDebit/DirectDebitChangePage";
import {DirectDebitAddPage} from "../pages/dashboard/common/payments/changeDirectDebit/DirectDebitAddPage";
import {PayOverdueInstalmentPage} from "../pages/dashboard/common/payments/missedPayment/PayOverdueInstalmentPage";
import {OutstandingPaymentPage} from "../pages/dashboard/common/payments/missedPayment/OutstandingPaymentPage";
import {
    DirectDebitRenewalChangePaymentDayPage
} from "../pages/dashboard/common/payments/DirectDebitRenewalChangePaymentDayPage";
import {MigratedRenewalPage} from "../pages/dashboard/annual/motor/dashboardPage/MigratedRenewalPage";
import {
    MigratedRenewalAnnualAccountDetailsPage
} from "../pages/dashboard/annual/motor/MigratedRenewalAnnualAccountDetailsPage";
import {OldDriveAwayPolicySummaryPage} from "../pages/dashboard/driveaway/oldPolicies/OldDriveAwayPolicySummaryPage";
import {
    MigratedRenewalDocumentsPage
} from "../pages/dashboard/annual/motor/migratedRenewal/MigratedRenewalDocumentsPage";
import {
    MigratedRenewalPaymentDetailsPage
} from "../pages/dashboard/common/payments/paymentDetails/annual/MigratedRenewalPaymentDetailsPage";
import {HelpPage} from "../pages/dashboard/common/HelpPage";
import {MigratedRenewalHelpPage} from "../pages/dashboard/annual/motor/migratedRenewal/MigratedRenewalHelpPage";
import type {ICustomerPortalService} from "../services/ICustomerPortalService";
import { CustomerPortalServiceImpl } from "../services/impl/CustomerPortalServiceImpl";
import { Types as CustomerPortalTypes } from "../Types";

const plugin: IPlugin<IDashboardPluginConfig> = {
    getName(): string {
        return "dashboard";
    },

    register(extensions: IExtensionPoints, configuration: IDashboardPluginConfig): void {
        // Routes
        extensions.routes.add(
            {
                path: "/dashboard",
                component: MultiPoliciesDashboardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/:policyNumber",
                component: AnnualMotorDashboardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/migratedRenewal",
                component: MigratedRenewalPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/driveAway/:policyNumber",
                component: DriveAwayDashboardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/pickClaimKind",
                component: PickClaimKindPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/pickMotorClaimKind/:policyNumber",
                component: PickMotorClaimKindPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/motorWindscreenOrOtherPage/:policyNumber",
                component: WindscreenOrOtherClaimPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/yourCars/:policyNumber",
                component: AnnualYourCarsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/policySummary/:policyNumber",
                component: YourCarCoverPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/driveAway/policySummary/:policyNumber",
                component: YourDriveAwayCarCoverPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/oldPolicies",
                component: OldPoliciesPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorOldPolicies/:policyNumber",
                component: OldMotorPolicySummaryPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/driveAwayOldPolicies/:policyNumber",
                component: OldDriveAwayPolicySummaryPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/multiPolicy/account",
                component: MultiPolicyAccountDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/marketingPreferences",
                component: MarketingPreferencesPage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorAccount/:policyNumber",
                component: AnnualAccountDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard/:policyNumber/:paymentReference",
                component: ChangeCardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard/:policyNumber",
                component: ChangeCardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard2/:paymentReference",
                component: ChangeCardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard",
                component: ChangeCardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changePaymentDay/:policyNumber",
                component: DirectDebitChangePaymentDayPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeRenewalPaymentDay/:policyNumber",
                component: DirectDebitRenewalChangePaymentDayPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPayment",
                component: MissedPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPolicyPayment/:policyNumber",
                component: MissedPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPolicyPayment/:policyNumber/:invoiceId",
                component: MissedPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/payOverdueInstalment/:policyNumber",
                component: PayOverdueInstalmentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/payOverdueInstalment/:policyNumber/:invoiceId",
                component: PayOverdueInstalmentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/outstandingPayment/:policyNumber/:invoiceId",
                component: OutstandingPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPayment/:paymentReference",
                component: MissedPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing",
                component: PaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference",
                component: PaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference/:policyNumber",
                component: PaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference/:policyNumber/:invoiceId",
                component: PaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/newCardPayment/:policyNumber",
                component: NewCardPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/:policyNumber/cardPaymentProcessing",
                component: CardPaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/:policyNumber/cardPaymentProcessing/:paymentReference",
                component: CardPaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualPaymentHistory/:policyNumber",
                component: AnnualPaymentDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/monthlyPaymentHistory/:policyNumber",
                component: MonthlyPaymentsDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/paymentDetails/editDirectDebit/",
                component: DirectDebitChangePage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/paymentDetails/addDirectDebit/",
                component: DirectDebitAddPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/quotes",
                component: QuotesPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualQuotes",
                component: AnnualQuotesPage,
            }
        );

        extensions.routes.add({
            path: "/dashboard/viewOrGetQuotes",
            component: ViewOrGetQuotesPage,
        });

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorDocuments/:policyNumber",
                component: DocumentsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/migratedRenewalDocuments",
                component: MigratedRenewalDocumentsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/driveAwayDocuments/:policyNumber",
                component: DocumentsPage,
            }
        );

        extensions.routes.add({
            path: "/dashboard/getNewQuote",
            component: GetNewQuotePage,
        });

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance",
                component: PayOffBalancePage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance/newCard",
                component: PayOffBalanceNewCardPage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance/processing/:paymentReference",
                component: PayOffBalanceProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/migratedRenewal/annualMotorAccount",
                component: MigratedRenewalAnnualAccountDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/migratedRenewal/paymentDetails",
                component: MigratedRenewalPaymentDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/migratedRenewal/help",
                component: MigratedRenewalHelpPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/help/:policyNumber",
                component: HelpPage,
            }
        );

        // Services
        extensions.services.bind<ICustomerPortalService>(CustomerPortalTypes.CustomerPortalService).to(CustomerPortalServiceImpl);
        extensions.services.bind<IServiceConfig>(CustomerPortalTypes.CustomerPortalServiceConfig).toConstantValue(configuration.customerPortalApiService);
        extensions.services.bind<IBaseRequestService>(Types.BaseRequestService).to(BaseRequestServiceImpl);
    },
};

export default plugin;
